import { render, staticRenderFns } from "./AppLayoutSettings.vue?vue&type=template&id=c83fbfea"
import script from "./AppLayoutSettings.vue?vue&type=script&lang=js"
export * from "./AppLayoutSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports